import React, { useState } from 'react';
import styles from './Popup.module.scss';
import { LocationOptions } from '../LocationOptions';
import IconClose from '../../assets/icons/close.svg';
import IconBack from '../../assets/icons/icon-back.svg';
import IconBackDark from '../../assets/icons/icon-back-dark.svg';
import { buildUrl } from 'utils/helpers';

const Popup = (props) => {
  const { 
    sites,
    setFilter,
    homeURL,
    colorScheme,
    movieName,
    showSearch,
    concessionBtnText,
    concessionSiteLink,
    concessionLinkNewTab,
    concessionEnabledParam,
    testCinemasEnabled
  } = props

  const [isActive, setIsActive] = useState(false);

  const handleCloseClick = (e) => {
    e.preventDefault();

    setIsActive(false);
  }

  const iconBackSrc = colorScheme === 'light' ? IconBackDark : IconBack;
  const isDropDownLayout = !!document.querySelector('.popup__choose-cinema.as-drop-down');

  return (
    <div className={styles.browserPopup + ' ' + (isActive ? styles.active : '') + ' ' + (isDropDownLayout ? styles.dropDownLayout : '')}>
      { !isDropDownLayout &&
        <div className={styles.browserPopupHeader}>
          <div className={styles.browserPopupHeaderInner}>
            <button type="button" className={styles.btnMobile + " bnt-close-popup"} onClick={handleCloseClick}>
              <img src={buildUrl([homeURL, iconBackSrc])} className={styles.iconBack} alt={window.mapiTranslations['back icon']} />
            </button>

            <h3>{window.mapiTranslations['Select Cinema'] || 'Select Cinema'}</h3>

            <button type="button" className={styles.btnDesktop + " bnt-close-popup"} onClick={handleCloseClick}>
              <img src={buildUrl([homeURL, IconClose])} className={styles.iconClose} alt={window.mapiTranslations['close icon']} />
            </button>
          </div>

          { movieName &&
            <h5 className={styles.movieTitle}>{movieName}</h5>
          }
        </div>
      }

      <LocationOptions 
        cinemas={sites} 
        setFilter={setFilter}
        isPopup={true}
        homeURL={homeURL}
        colorScheme={colorScheme}
        showSearch={showSearch}
        concessionBtnText={concessionBtnText}
        concessionSiteLink={concessionSiteLink}
        concessionLinkNewTab={concessionLinkNewTab}
        concessionEnabledParam={concessionEnabledParam}
        testCinemasEnabled={testCinemasEnabled} 
      />
    </div>
  );
}

export { Popup };
